<script>
import { computed, defineComponent, watch } from '@vue/composition-api';
import Loader from '../components/Loader.vue';

export default defineComponent({
  components: {
    Loader,
  },
  setup(props, { root }) {
    const router = root.$router;
    const profile = computed(() => root.$store.getters.getProfile);
    const customer = computed(() => root.$store.getters.getCustomer);

    watch(profile, () => {
      if (profile.value && !profile.disabled) {
        if (customer.value.onlyCatalogue) {
          router.push('/produtos');
        } else if (profile.value.manager || profile.value.director) {
          router.push('/dashboard/gestor');
        } else if (profile.value.seller) {
          router.push('/campaigns');
        }
      } else if (profile.disabled) {
        router.push('/404');
      }
    }, { immediate: true });

    return {
      profile,
    };
  },
});
</script>
<template>
  <Loader class="mt-4" />
</template>

<style scoped>
.container {
  padding-left: 8px;
  padding-right: 8px;
  padding-top: 0px;
}
</style>
